import Resource from "../../shared/actions/resourceActions";

export default class UnitCatalogResource extends Resource {
  constructor(dispatch, unitId) {
    super(dispatch, "unit", `/api/v1/units/${unitId}/catalog`);
  }
}
